import React from 'react'
import { SectionCard } from './common'
import DataTable from './Tables'
import { useGetConfigQuery } from '../../../redux/d2cApiSlice'

// Read-only display of the model-enforced COD/RTO rails — single source of truth is
// config.serviceRails (the same values the pricing engine clamps to). Shown in the FH view,
// L1 pricing view, and admin page so the hardcoded/enforced limits are always transparent.
const SVC_LABEL = { FWD_SURFACE: 'FWD Surface', FWD_AIR: 'FWD Air', SDD_NDD: 'SDD / NDD' }

export default function PricingRailsCard() {
  const { data: config } = useGetConfigQuery()
  const rails = config?.serviceRails || []
  if (!rails.length) return null

  const fmt = (flat, pct) => `₹${flat ?? '—'} / ${pct ?? '—'}%`
  const rows = rails.map((r) => ({
    service: SVC_LABEL[r.serviceType] || r.serviceType,
    codMin: fmt(r.codFloorFlat, r.codFloorPct),
    codMax: fmt(r.codCeilFlat, r.codCeilPct),
    rto: `${r.rtoFloorPct ?? '—'}% – ${r.rtoCeilPct ?? '—'}%`,
  }))
  const columns = [
    { key: 'service', label: 'Service', render: (r) => <b>{r.service}</b> },
    { key: 'codMin', label: 'COD min (₹ / % of invoice)' },
    { key: 'codMax', label: 'COD max (₹ / % of invoice)' },
    { key: 'rto', label: 'RTO (% of forward)' },
  ]
  return (
    <SectionCard
      title="Pricing rails — model-enforced (ex-GST)"
      subtitle="Every generated proposal is clamped to these COD & RTO limits — regardless of margin, target, or the SL's entered rate. COD min/max is the higher of the flat ₹ or the % of invoice value."
    >
      <DataTable columns={columns} rows={rows} getRowKey={(r) => r.service} />
    </SectionCard>
  )
}
